/* eslint-disable react/require-default-props */
import React, { CSSProperties, ReactNode } from 'react';
import Link from 'next/link';
import url from '@/utils/config';

type Props = {
  variant: 'primary' | 'secondary';
  href: any;
  children: ReactNode;
  disabled?: boolean;
  style?: CSSProperties;
  ariaLabel?: string;
  target?: React.HTMLAttributeAnchorTarget;
  rel?: string;
};

/**
 * リンク用ボタンのコンポーネント
 * @param variant ボタン表示種別
 * @param href リンクURL
 * @param children リンクボタン情報
 * @param disabled ボタン活性／非活性（true = 非活性、false = 活性）
 * @param ariaLabel ARIAラベル
 * @returns 表示用コンポーネント
 */
const LinkButton = ({
  variant,
  href,
  children,
  disabled = false,
  style,
  ariaLabel,
  target,
  rel,
}: Props) => {
  // 非活性の場合は、ボタン表示処理のみを実施する
  // 「Link」を使用すると操作する動作してしまうため
  if (disabled) {
    // 見た目はボタンのまま保ちつつ、遷移だけ無効化したい場面に使う。
    return (
      <div className={`m-button__inner ${variant === 'secondary' ? 'm-button--sec' : ''} disabled`}>
        <span className='m-button__txt'>{children}</span>
        <img className='m-button__icon' src={url('/images/icon_arrow_right-02.svg')} alt='' />
      </div>
    );
  }
  return (
    // 活性時だけ Next.js の Link を使い、ページ遷移をアプリ内ナビゲーションに寄せる。
    <Link
      href={href}
      as={href.pathname ? href.pathname : href}
      className={`m-button__inner ${variant === 'secondary' ? 'm-button--sec' : ''}`}
      style={style}
      aria-label={ariaLabel}
      target={target}
      rel={rel}
    >
      <span className='m-button__txt'>{children}</span>
      <img className='m-button__icon' src={url('/images/icon_arrow_right-02.svg')} alt='' />
    </Link>
  );
};
LinkButton.defaultProps = {
  ariaLabel: undefined,
  target: undefined,
  rel: undefined,
};

export default LinkButton;
